<div class="story-modal-wrapper">
  <mat-dialog-content>
    <div>
      <button class="cmn-close" (click)="onNoClick()"></button>
      <div class="imageWrapper">
        <div
          *ngIf="checkFile(data.image)"
          style="height: 800px; overflow: hidden"
        >
          <iframe
            [src]="(data.image + '#toolbar=0') | safeUrl"
            style="width: 100%; height: 100%; border: none"
            scrolling="no"
          >
          </iframe>
        </div>
        <img
          *ngIf="!checkFile(data.image)"
          [src]="data.image || '../../../assets/images/placeHolderImage.jpg'"
          alt="Poster Image"
        />
      </div>
    </div>
  </mat-dialog-content>
</div>
